export const version = '0.811.1'
export const chameleonWebVersion = '10.3.1'
export const chameleonCoreVersion = '7.12.1'
